import { AgGridReact } from "ag-grid-react";
import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback,
} from "react";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../config";
import "../css/dpi-styles.css";
import axios from "axios";
import Reportstats from "../components/Reportstats";
//import UPLOAD_FOLDER_LOCATION from "../config";

export default function SurveyAnalyze() {
  const folderLocation = process.env.REACT_APP_UPLOAD_FOLDER;
  let navNaigate = useNavigate();
  const handlenavigate = (path) => {
    navNaigate(path);
  };
  const [userRespList, setUserRespList] = useState([]);
  const [userResponse, setUserResponse] = useState([]);
  const [selectedResponse, setSelectedResponse] = useState(0);

  const [userRespColsDef, setUserRespColsDef] = useState([]);
  const [isCsvLoading, setIsCsvLoading] = useState(false);
  const [isShowChart, setIsShowChart] = useState(false);
  const [surveyCharts, setSurveyCharts] = useState([]);
  const [isLoading, setIsLoading] = useState(false); // State to track loading status

  /*const [userRespColsDef, setUserRespColsDef] = useState([
    {
      field: "surv_user_resp_id",
      width: 180,
      headerName: "Reponse Id",
    },
    {
      field: "date_created",
      width: 180,
      headerName: "Create Date",
    },
  ]);*/

  const defaultColDef = useMemo(() => ({
    filter: true, // Enable filtering on all columns
  }));

  useEffect(() => {
    const getAllSurveyUserResponse = async () => {
      const resUserRes = await fetch(
        `${API_BASE_URL}GetAllSurveyUserResponse.php/${
          JSON.parse(sessionStorage.getItem("new_survey")).surv_id
        }`
      );
      if (resUserRes.ok) {
        const resuserResjson = await resUserRes.json();
        if (!resuserResjson.message) {
          // Step 1: Generate dynamic column definitions based on data keys
          const dynamicColumnDefs = Object.keys(resuserResjson[0]).map(
            (key) => ({
              headerName: key.charAt(0).toUpperCase() + key.slice(1), // Capitalize header
              field: key,
              sortable: true,
              filter: true,
            })
          );
          setUserRespColsDef(dynamicColumnDefs);
          setUserRespList(resuserResjson);
        }
        //console.log(resuserResjson);
      } else {
        setUserRespList([]);
      }
    };
    getAllSurveyUserResponse();
  }, [JSON.parse(sessionStorage.getItem("new_survey")).surv_id]);

  useEffect(() => {
    const getUserResponse = async () => {
      if (selectedResponse > 0) {
        const resUserResponse = await fetch(
          `${API_BASE_URL}GetUserResponseByRespId.php/${selectedResponse}/${
            sessionStorage.getItem("new_survey")
              ? JSON.parse(sessionStorage.getItem("new_survey")).surv_id
              : 0
          }`
        );
        if (resUserResponse.ok) {
          const resUserResponseJson = await resUserResponse.json();
          setUserResponse(await resUserResponseJson.data);
        } else {
          setUserResponse([]);
        }
      }
    };
    getUserResponse();
  }, [selectedResponse]);

  /*useEffect(() => {
    getUserResponse();
  }, [selectedResponse]);

  const getUserResponse = async () => {
    const formfldData = new FormData();
    formfldData.append("surv_user_resp_id", selectedResponse);
    formfldData.append(
      "surv_id",
      sessionStorage.getItem("new_survey")
        ? JSON.parse(sessionStorage.getItem("new_survey")).surv_id
        : 0
    );

    const templsaver = await axios
      .post(`${API_BASE_URL}GetUserResponseByRespId.php`, formfldData, {
        hearders: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        setUserResponse(response.data);
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  };*/
  const openDoc = (file_name) => {
    const windowFeatures =
      "width=600,height=400,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,,toolbar=no";
    const filePath = `${folderLocation}${file_name}`;
    window.open(filePath, "_blank", windowFeatures);
    //console.log(folderLocation);
  };

  const convertToCSV = (data) => {
    const headers = Object.keys(data[0]);
    const csvRows = [];

    // Add the headers to the CSV
    csvRows.push(headers.join(","));

    // Add the data rows
    data.forEach((row) => {
      const values = headers.map((header) => {
        const escaped = ("" + row[header]).replace(/"/g, '\\"');
        return `"${escaped}"`;
      });
      csvRows.push(values.join(","));
    });

    return csvRows.join("\n");
  };

  const downloadCSV = () => {
    setIsCsvLoading(true);
    const csvData = convertToCSV(userRespList);
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    const fileName = sessionStorage.getItem("new_survey")
      ? JSON.parse(sessionStorage.getItem("new_survey")).surv_name
      : "data";
    a.setAttribute("href", url);
    a.setAttribute("download", fileName + ".csv");
    a.click();
    setIsCsvLoading(false);
  };

  const showSurveyCharts = () => {
    setIsShowChart(true);
    getSurveyCharts();
  };

  const showSurveyDetails = () => {
    setIsShowChart(false);
  };

  const getSurveyCharts = async () => {
    setIsLoading(true);
    try {
      const formfldData = new FormData();
      formfldData.append(
        "surv_id",
        sessionStorage.getItem("new_survey")
          ? JSON.parse(sessionStorage.getItem("new_survey")).surv_id
          : 0
      );

      const templsaver = await axios
        .post(`${API_BASE_URL}GetSurveyChartsBySurvId.php`, formfldData, {
          hearders: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          //console.log(response.data.data);
          setSurveyCharts(response.data.data);
        })
        .catch((error) => {
          console.log(error);
          return false;
        });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="col-xl-6 mx-auto">
        <div className="row">
          <div className="col-md-4">
            <button
              className="btn btn-primary disabled btn-circle"
              id="btn_share_link"
              style={{ cursor: "pointer" }}
              onClick={() => handlenavigate("/surveyadd")}
              title="Create desired user input fields for your customize survey form"
            >
              1
            </button>
            &nbsp;&nbsp;
            <a
              className="mt-2"
              style={{ cursor: "pointer" }}
              onClick={() => handlenavigate("/surveyadd")}
            >
              Design
            </a>
          </div>
          <div className="col-md-4">
            <button
              className="btn btn-primary disabled btn-circle"
              id="btn_share_link"
              style={{ cursor: "pointer" }}
              onClick={() => handlenavigate("/surveysetup")}
              title="Choose users for your survey form or share survey link to specific participants"
            >
              2
            </button>
            &nbsp;&nbsp;
            <a
              class="mt-2"
              style={{ cursor: "pointer" }}
              onClick={() => handlenavigate("/surveysetup")}
            >
              Setup
            </a>
          </div>
          <div className="col-md-4">
            <button
              className="btn btn-primary btn-circle"
              id="btn_share_link"
              style={{ cursor: "pointer" }}
              onClick={() => handlenavigate("/surveyanalyze")}
              title="Analyze and access participants input and generate reports"
            >
              3
            </button>
            &nbsp;&nbsp;
            <a
              class="mt-2"
              style={{ cursor: "pointer" }}
              onClick={() => handlenavigate("/surveyanalyze")}
            >
              Analyze
            </a>
          </div>
        </div>
        <hr />
        <h3>
          {sessionStorage.getItem("new_survey")
            ? JSON.parse(sessionStorage.getItem("new_survey")).surv_name
            : ""}
        </h3>
        <div>&nbsp;</div>
        <div class="row card mb-3">
          <div class="card-body small">
            <ul>
              <li>
                Click on the user response row to see complete detailed response
                in lower pane.
              </li>
              <li>
                To view user uploaded files, you can click on the file name
                link.
              </li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-12" style={{ textAlign: "right" }}>
            {isCsvLoading ? <span className="spinner-border"></span> : ""}
            &nbsp;&nbsp;
            <lable className="small">Export to CSV</lable>
            {Object.keys(userRespList).length > 0 ? (
              <i
                className="icon fas fa-download mx-2"
                title="Export to CSV"
                onClick={downloadCSV}
              ></i>
            ) : (
              <i
                className="disabled fas fa-download mx-2"
                title="Export to CSV"
              ></i>
            )}
          </div>
        </div>
        <div className="row">
          <div
            id="user_resp"
            //className="ag-theme-quartz"
            className="ag-theme-quartz"
            style={{
              width: "100%",
              height: 300,
            }}
          >
            <AgGridReact
              //ref={gridRef}
              rowData={userRespList}
              columnDefs={userRespColsDef}
              defaultColDef={defaultColDef}
              rowSelection={"multiple"}
              onRowClicked={(param) => setSelectedResponse(param.data.Id)}
              pagination={true}
            />
          </div>
        </div>
        <div>&nbsp;</div>
        <nav>
          <div className="nav nav-tabs" id="nav-tab" role="tablist">
            <a
              className="nav-item nav-link active"
              id="nav-patient-tab"
              data-toggle="tab"
              type="button"
              //href="#nav-patient"
              onClick={() => showSurveyDetails()}
              role="tab"
              aria-controls="nav-patient"
              aria-selected="true"
            >
              <i className="fas fa-file-alt"></i>
              &nbsp;&nbsp;&nbsp;Details&nbsp;&nbsp;&nbsp;
            </a>
            &nbsp;
            <a
              className="nav-item nav-link"
              //className="nav-item nav-link"
              id="nav-invest-tab"
              data-toggle="tab"
              //href="#nav-investigation"
              onClick={() => showSurveyCharts()}
              role="tab"
              aria-controls="nav-investigation"
              aria-selected="false"
              aria-disabled="true"
            >
              <i className="fas fa-chart-pie"></i>&nbsp;Stats & Graphs
            </a>
            &nbsp;
          </div>
        </nav>

        {userRespList && userResponse && !isShowChart && (
          <div class="row card mt-4">
            <div class="card-body small">
              <table className="ag-grid-like-table">
                {/*<thead>
                  <tr>
                    <th>Question</th>
                    <th>Response</th>
                  </tr>
                </thead>*/}
                <tr>
                  <td>Question</td>
                  <td>Response</td>
                </tr>

                {userResponse?.map((resp, index) => (
                  <tr>
                    <td>{resp.surv_ques_label}</td>
                    {resp.ctrl_name === "File Uploader" ? (
                      <td>
                        <a
                          href={
                            resp.input_val
                              ? JSON.parse(resp.input_val)?.fileName
                              : ""
                          }
                          onClick={(e) => {
                            e.preventDefault(); // Prevent the default behavior if you want full control
                            openDoc(
                              resp.input_val
                                ? JSON.parse(resp.input_val)?.fileName
                                : ""
                            );
                          }}
                        >
                          {resp.input_val
                            ? JSON.parse(resp.input_val)?.file_base_name
                            : ""}
                        </a>
                        &nbsp;
                        {resp.input_val !== null && (
                          <i
                            className="icon fa fa-download"
                            onClick={(e) => {
                              e.preventDefault(); // Prevent the default behavior if you want full control
                              openDoc(
                                resp.input_val
                                  ? JSON.parse(resp.input_val)?.fileName
                                  : ""
                              );
                            }}
                          ></i>
                        )}
                      </td>
                    ) : (
                      <td>{resp.input_val}</td>
                    )}
                  </tr>
                ))}
              </table>
            </div>
          </div>
        )}
        {isShowChart && (
          <div className="row mt-3">
            {surveyCharts?.map((item, index) => {
              const prevItem = index > 0 ? surveyCharts[index - 1] : null;
              if (prevItem !== null) {
                if (item.surv_ques_label !== prevItem.surv_ques_label) {
                  return <Reportstats item={item} data={surveyCharts} />;
                }
              } else {
                return <Reportstats item={item} data={surveyCharts} />;
              }
            })}
            {isLoading && (
              <div className="loader">
                <div className="spinner"></div>
                <p>Generating stats, please wait...</p>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
